import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Paper, Button, Table, TableBody, Checkbox, TableCell, TableHead, TableRow, TableSortLabel, Grid } from "@mui/material";
import DeletePopUp from "../../../../shared_elements/components/DeletePopUp";
import { Pagination, STableLoader, PageLoader } from "../../../../shared_elements";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { checkApiStatus } from "../../../../utils";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { enqueueSnackbar } from "notistack";
import { ButtonLoader, ShowAttachments } from "../../../../shared_elements/components";
import MouList from "../components/MouList";
import { deleteMouApi, getMouApi } from "../apiServices";
import MouCRU from "../components/MouCRU";
import { mouOptionObj } from "../components";
import AssetsNav from "../../../elements/AssetsNav";
import { LeasesBasicDetails } from "../../../elements";
import AssetsMenueList from "../../../elements/AssetsMenuList";
import { RoleBaseAccess } from "../../../../hoc";
import { PermissionWrapper } from "../../../../wrappers";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FileUploadLayout from "../../../../shared_elements/components/FileUploadLayout";
import fileUpload, { getApiResponse } from "../../../../utils/fileUpload";
import { useDispatch, useSelector } from "react-redux";
import { getStorage } from "../../../../shared_elements/actionCreators";
import { trackActivity } from "../../../../utils/mixpanel";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 183px)';

const MouHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `MOU`, page_type: page_type, })
  }
  const tableSorting = (key, name) => {
    return (
      <TableSortLabel
        disabled={key === "lessee" || key === "lessor" ? true : false}
        hideSortIcon={key === "lessee" || key === "lessor" ? true : false}
        sx={{ whiteSpace: "nowrap" }}
        active={sortInfo.sort_by === key ? true : false}
        direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
        onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
      >
        {name}
      </TableSortLabel>
    )

  }

  return (
    <TableHead>
      <TableRow>
        <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "mou_list", operationType: ['D'] }}>
            <Checkbox size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
          </PermissionWrapper>
          Action(s) </TableCell>
        <TableCell>{tableSorting("mou_date", "MOU Date")}</TableCell>
        <TableCell > {tableSorting("lessee_id", "Lessee")}</TableCell>
        <TableCell>{tableSorting("lessor_id", "Lessor/Holdco")}</TableCell>
        <TableCell>{tableSorting("managed", "Managed")}</TableCell><TableCell > {tableSorting("tied_asset", "Linked Asset")} </TableCell>
      </TableRow>
    </TableHead>
  );
};

const Mou = () => {
  const dispatch=useDispatch()
  const params = useParams();
  const {fileUploadDetails} = useSelector((state) => state.leases);
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [mouInfo, setMouInfo] = useState({ list: [], pagination: null });
  const [addEditMou, setAddEditMou] = useState({ mode: '', modal: false, data: null });
  const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
  const [deletMou, setDeleteMou] = useState({ modal: false, data: null, })
  const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
  const[isExport,seIsExport]=useState(false)
  const[uploadFileProgressData, setUploadFileProgressData]=useState({})
  const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
  const [slug,setSlug]=useState({})

  useEffect(() => {
    const uploadedFileData = getApiResponse("mou_list", slug);
    getMouList('skeletonLoader', { per_page: 50 });
    trackActivity('Page Viewed',{ page_title: 'MOU'})
    setUploadFileProgressData({ uploadedFileData });
  }, []);

  const getMouList = (loaderType, query = {}) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(getMouApi(params, query)).then(response => {
      if (checkApiStatus(response)) {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        setMouInfo(response.data.data);
      }
    })
   dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"mou_list"}))
    
  }

  const deleteMouFn = () => {
    setLoading(true);
    const idsToDelete = deletMou?.modal && deletMou?.data?.id ? [deletMou?.data?.id] : (bulk?.ids || []).map(item => item?.id);
    globalDeleteService(deleteMouApi(params), { ids: idsToDelete } )
      .then(response => {
        if (checkApiStatus(response)) {
          trackActivity('Item Deleted', { page_title: `Delete MOU`, success_msg: response?.data?.message, item_ids: deletMou?.data || bulk?.ids, response: response?.data })
          setDeleteMou({ modal: false, data: null });
          getMouList('fetch', {per_page: mouInfo?.pagination?.per_page});
          setBulk({ modal: false, ids: [], title: '', type: '' })
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        } else {
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Deleted', { page_title: `Delete MOU`, error_msg: response?.data?.message, item_ids: deletMou?.data || bulk?.ids, response: response?.data })
        }
      })
  }
  const onDeteAttchments = (deltedslug) => {
    setAttachments({
      ...attachments, data: {
        ...attachments.data,
        attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
      }
    });
    if (addEditMou?.modal) {
      setAddEditMou({
        ...addEditMou,
        data: {
          ...addEditMou.data,
          attachments: addEditMou.data.attachments.filter(item => item?.slug !== deltedslug)
        }
      })
    }
    getMouList('', { per_page: mouInfo?.pagination?.per_page });
  }

  const toggleBulkOps = (flag, type, item) => {
    if (type === 'bulk') {
      setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
    } else {
      setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
    }
  }

  const createSortHandler = (key) => {
    let sortQuery = { sort_by: key };
    if (sortInfo.sort_by === key) {
      sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
    } else {
      sortQuery = { ...sortQuery, sort: 'asc' }
    }
    setSortInfo(sortQuery)
    getMouList('', { ...sortQuery,per_page: mouInfo?.pagination?.per_page });
  }

  const handleExport = () => {
    let query = { export: true }
    if (sortInfo?.sort && sortInfo?.sort_by) {
      query = {
        ...query,
        sort: sortInfo?.sort,
        sort_by: sortInfo?.sort_by
      }
    }
    seIsExport(true);
    globalGetService(getMouApi(params, query)).then((response) => {
      if (checkApiStatus(response)) {
        enqueueSnackbar(
          response?.data.message,
          { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
        );
        seIsExport(false);
      }
    })
  }
  
  const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "mou_list",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments,response }) => {
                setUploadFileProgressData({ progressRefs, attachments,response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                getMouList("", { per_page: mouInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
      setSlug({});
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `MOU`, page_type: page_type, })
  }

  return (
    <>
    <LeasesBasicDetails />
      <Paper className="lease-details-section lease-nav-module-margin lease-module-paper" elevation={0}>
      <AssetsNav />
      <div className='lease-details-content'>
          <Paper square className="responsive-paper">
            <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
              <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                <AssetsMenueList pageLabel={`mou`}/>
              </Grid>
              <Grid item md={8} xs={12}>
                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: 0 }}>
                  <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"asset"} })}/></li>
                  {
                    bulk?.type && bulk?.ids?.length ?
                      <>
                        <li className='lease-mobile-button'>
                          <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                        </li>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "mou_list", operationType: ['D'] }}>
                          <li className='lease-mobile-button'>
                            <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                          </li>
                        </PermissionWrapper>
                      </> : null
                  }
                  {mouInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button className='btn-primary action-btn-start-icon' startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small'> Export </Button> </li> : null}
                  <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "mou_list", operationType: ['C'] }}>
                    <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' variant="contained" color="primary" size='small' onClick={() => { setAddEditMou({ modal: true, data: mouOptionObj, mode: 'add' }); handleItemClicked('Add Item Button') }} > Add MOU </Button> </li>
                  </PermissionWrapper>
                </ul>
              </Grid>
            </Grid>
          </Paper>
           <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: mouInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
              <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                {skeletonLoader ? <STableLoader count={4} rowCount={13} /> : (
                  <Table className="mui-table-format" stickyHeader>
                    <MouHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={mouInfo?.list} toggleBulkOps={toggleBulkOps} />
                    <TableBody>
                      {mouInfo?.list?.length > 0 && mouInfo?.list?.map((item, index) =>{
                           const uploadedFileData = getApiResponse("mou_list", item?.slug);
                        return(
                        <MouList
                          slug={slug?.slug}
                          uploadedFileData={uploadedFileData}
                          uploadFileProgressData={uploadFileProgressData}
                          viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                          key={index}
                          item={item}
                          bulk={bulk}
                          viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                          onEditFn={() => setAddEditMou({ modal: true, data: item, mode: 'edit' })}
                          onView={() => setAddEditMou({ modal: true, data: item, mode: 'view' })}
                          onDeleteEolFn={() => {
                            setDeleteMou({ modal: true, data: item, });
                            setBulk({ modal: false, ids: [item], type: '', title: '' })
                          }}
                          toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                          onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                        />
                      )})}
                    </TableBody>
                  </Table>
                )}
                {!skeletonLoader && !mouInfo?.list?.length && <NoRecordFound />}
              </div>
              <Paper square>
                <Pagination
                  pagination={mouInfo?.pagination}
                  onPageChange={(event, newPage) => { const pageNum = newPage + 1; getMouList('pageLoader', { page: pageNum, per_page: mouInfo.pagination.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}), }); }}
                  onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getMouList('pageLoader', { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}), }); }}
                />
              </Paper>
            </Paper>
      </div>
      {addEditMou.modal &&
        <MouCRU
          fileUpload={handleUpload}
          addEditMou={addEditMou}
          modeType={addEditMou?.mode}
          getResponseBack={() => {getMouList('fetch',{per_page: mouInfo?.pagination?.per_page}); setBulk({modal: false, ids: [], type: '', title: ''})}}
          onOpenAttachments={() => setAttachments({ modal: true, data: addEditMou?.data, mode:'view' })}
          onToggleModal={() => setAddEditMou({ modal: false, data: null, mode: '' })}
        />
      }
      {deletMou.modal &&
        <DeletePopUp
          modal={deletMou.modal}
          title='Delete Mou Option'
          content={`Are you sure, you want to Delete?`}
          onToggleModal={() => {
            setDeleteMou({ modal: false, data: null });
            setBulk({modal: false, ids: [], title: '', type: ''});
          }}
          onDeleteRecords={() => deleteMouFn()}
        />}
      {attachments.modal ?
        <ShowAttachments
          moduleName="Mou Option"
          url='delete-attachment'
          attachmentsData={attachments}
          getResponseBack={onDeteAttchments}
          toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
          onViewDisabled={addEditMou?.mode === 'view' || attachments?.mode==='view'}
          permissionKey='mou_list'
        /> : null
      }
      {bulk.modal ?
        <DeletePopUp
          modal={bulk.modal}
          title={`Delete ${bulk?.ids?.length === (mouInfo?.list?.length || 0) ? "All Mou Option" : "Selected Mou Option"}`}
          onDeleteRecords={() => deleteMouFn()}
          content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
          onToggleModal={() => setBulk({ modal: false, ids: [], title: '', type: '' })}
        /> : null
      }
      {
          revisionHistory.modal &&  
          <RevisionHistory 
           asset_type={params?.basic_info}
           asset_slug={params?.asset_slug}
           moduleName={"mou_list"}
           revisionHistory={revisionHistory}
           onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
          />
        }
          <FileUploadLayout
          uploadFileStatus={uploadFileStatus}
          open={uploadFileStatus?.modal}
          setUploadFileStatus={setUploadFileStatus}
          uploadFileProgressData={uploadFileProgressData}
          progressRefs={uploadFileProgressData?.progressRefs}
          attachments={uploadFileProgressData?.attachments}
          onDownloadComplete={()=> setSlug({})}
          />

      {isLoading ? <PageLoader /> : null}
    </Paper >
    </>
  );

};

export default RoleBaseAccess(Mou, { application: 'lease_revamp', feature: 'mou_list', operationType: ['R'] });
